import request from '@/utils/request';
import { ResCode, CommonResponse, PagingResData, PagingReq, Operation, Admin, Meter, MeterFault, MeterAlarm } from './baseDefine';

export interface AdminCommonReq extends PagingReq {
    admin: Admin;     // admin
}

// 修改密码
export interface ReqUpdatePassword {
    oldPassword: string;      // 邮箱验证码
    newPassword: string;      // 密码
    confirmPassword: string;  // 确认密码
}
// 用户注册
export interface NewAdminReq {
    userName: string;
    email: string;           // 邮箱
    password: string;        // 密码
    confirmPassword: string; // 确认密码
    companyID: number;
    companyName: string;
}

export interface UserList {
    code: ResCode;
    msg: string;
    data: UsersRes;
}
/**
 *
 * 获取概览的请求
 * @export
 * @interface OverviewReq
 */
export interface OverviewReq {
    historyMeterTypeID: number;
    date: string;                    // 日期
    meter: Meter;
    timeID: number;
    nowDate: string;
    yesterday: string;
}

// 获取验证码
export interface GetEmailCodeReq {
    email: string;  // 邮箱
    type: number;    // 获取的类型  0-注册  1-忘记密码  2-修改密码
}
// 修改密码
export interface ForgetPasswordReq {
    email: string;              // 邮箱
    emailCode: string;          // 邮箱验证码
    password: string;           // 密码
    comfirmPassword: string;    // 确认密码
}
export interface UsersRes {
    users: UsersData;
}
export interface UsersData {
    list: Admin[];
    backRoles: string[];
    frontRoles: string[];
    curPage: number;
    totalPage: number;
    totalCount: number;
    nextPage: number;
}
export interface AdminOprationList {
    code: ResCode;
    msg: string;
    data: GetAdminOperationRes;
}

export interface OverviewRes {
    code: ResCode;
    msg: string;
    data: OverviewResData;
}
export interface OverviewResData {
    meterFaults: MeterFault[];
    meterAlarms: MeterAlarm[];
    meterState: number[];
    meterCount: number[];
    historys: History[];
    alarmCount: number;
}

export interface History {
    time: string;        // 日期
    usage: number;       // 用量
    cost: number;        // 花费
    reading: number;
}

export interface QiniuTokenRes {
    code: ResCode;
    msg: string;
    data: {
        token: string;
        domain: string;
    };
}

export interface GetOperateReq extends PagingReq {
    adminID: number;
    searchCompanyID: number;
}

export interface GetAdminOperationRes {
    adminOperationData: AdminOperationData;
}
export interface AdminOperationData extends PagingResData {
    list: Operation[]
}
export function users(req: AdminCommonReq): Promise<UserList> {
    return request.post<UserList>('/admin/auth/getUserList', req);
}

export function operations(req: PagingReq): Promise<AdminOprationList> {
    return request.post<AdminOprationList>('/admin/operate/getOperations', req);
}

export function updatePassword(req: ReqUpdatePassword): Promise<CommonResponse> {
    return request.post<UserList>('/admin/auth/updatePassword', req);
}

export function updateAdmin(req: AdminCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/auth/updateAdmin', req);
}
export function deleteAdmin(req: AdminCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/auth/deleteAdmin', req);
}
export function newAdmin(req: AdminCommonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/auth/signUP', req);
}
export function overviewRequest(req: OverviewReq): Promise<OverviewRes> {
    return request.post<OverviewRes>('/admin/auth/overview', req);
}
export function getEmailCode(req: GetEmailCodeReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/auth/getEmailCode', req);
}
export function forgetPassword(req: ForgetPasswordReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/auth/forgetPassword', req);
}
export function getQiniuToken(): Promise<QiniuTokenRes> {
    return request.get<QiniuTokenRes>('/api/user/qiuniuToken', {});
};